export const TIMEZONES = [
  'Europe/Athens',
  'Europe/Nicosia',
  'Europe/Bucharest',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'UTC',
  'America/New_York',
] as const;

export function timezoneChoices(current: string): readonly string[] {
  return (TIMEZONES as readonly string[]).includes(current) ? TIMEZONES : [current, ...TIMEZONES];
}
